// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__-cto7","title":"Navigation_title__zeIYO"};